module.exports = __webpack_public_path__ + "assets/img/62fda164bd10b6da2747981505d9174b.svg";